/**
 * WhyTalkAustralia Component
 * Trust section with 5-Star Reviews, Family Owned, Local, One-Stop Shop, We Understand Your Business
 * Appears in ALL tiers
 */

import React from 'react';

const styles = {
  container: {
    padding: '60px 20px',
    backgroundColor: '#1A2332',
    borderRadius: '8px',
    marginBottom: '40px',
  },
  title: {
    fontSize: '36px',
    fontWeight: '700',
    color: '#FFFFFF',
    marginBottom: '12px',
    textAlign: 'center',
  },
  subtitle: {
    fontSize: '18px',
    color: '#BBBEC7',
    textAlign: 'center',
    marginBottom: '60px',
    maxWidth: '600px',
    margin: '0 auto 60px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: '24px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  card: {
    padding: '32px 24px',
    borderRadius: '8px',
    border: '1px solid #2A3444',
    backgroundColor: '#0F1729',
    transition: 'all 0.3s ease',
    textAlign: 'center',
    cursor: 'pointer',
  },
  cardHover: {
    borderColor: '#0057FF',
    backgroundColor: 'rgba(0, 87, 255, 0.05)',
    transform: 'translateY(-4px)',
    boxShadow: '0 12px 24px rgba(0, 87, 255, 0.15)',
  },
  icon: {
    fontSize: '48px',
    marginBottom: '16px',
    display: 'block',
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#FFFFFF',
    marginBottom: '12px',
  },
  cardDescription: {
    fontSize: '14px',
    color: '#BBBEC7',
    lineHeight: '1.5',
  },
};

/**
 * Card component for individual trust signals
 */
function TrustCard({ icon, title, description }) {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div
      style={{
        ...styles.card,
        ...(isHovered && styles.cardHover),
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span style={styles.icon}>{icon}</span>
      <h3 style={styles.cardTitle}>{title}</h3>
      <p style={styles.cardDescription}>{description}</p>
    </div>
  );
}

/**
 * WhyTalkAustralia Component
 */
function WhyTalkAustralia({ prospect }) {
  const trustSignals = [
    {
      id: 'reviews',
      icon: '⭐',
      title: '5-Star Reviews',
      description: 'Trusted by hundreds of businesses across Australia with consistently high ratings.',
    },
    {
      id: 'family',
      icon: '👨‍👩‍👧‍👦',
      title: 'Family Owned',
      description: 'A family-run business with decades of experience serving the Australian market.',
    },
    {
      id: 'local',
      icon: '🏢',
      title: 'Local Support',
      description: 'Australian-based support team that understands your local market and timezone.',
    },
    {
      id: 'onestop',
      icon: '🛍️',
      title: 'One-Stop Shop',
      description: 'Complete solutions for all your needs in one trusted partner.',
    },
    {
      id: 'understand',
      icon: '🎯',
      title: 'We Understand Your Business',
      description: 'Deep expertise in your industry and unique business challenges.',
    },
  ];

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Why Talk Australia?</h2>
      <p style={styles.subtitle}>
        Here's what makes us the trusted partner for {prospect?.industry || 'your industry'}
      </p>

      <div style={styles.grid}>
        {trustSignals.map((signal) => (
          <TrustCard
            key={signal.id}
            icon={signal.icon}
            title={signal.title}
            description={signal.description}
          />
        ))}
      </div>
    </div>
  );
}

WhyTalkAustralia.propTypes = {
  prospect: function (props, propName) {
    if (props[propName] != null && typeof props[propName] !== 'object') {
      return new Error(`${propName} must be an object`);
    }
  },
};

export default WhyTalkAustralia;
